@use 'src/styles/config.module' as *;

.tabs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(23rem, 1fr));
  grid-gap: 2rem;
  padding: 0 0 1.6rem;
  .tab {
    padding: 1rem 1.6rem 1rem 1.4rem;
    min-height: 5.2rem;
    background: #fff;
    border-radius: 0.4rem;
    color: $color-default;
    font-size: 1.4rem;
    justify-content: flex-start;
    .icon {
      position: relative;
      padding: 0 1.4rem 1px 0;
      svg {
        color: $color-primary;
      }
      &:before {
        content: '';
        position: absolute;
        top: -0.4rem;
        left: -0.2rem;
        width: 1.4rem;
        height: 1.4rem;
        border: 2px solid #fff;
        border-radius: 50%;
        background: $color-red;
      }
    }

    &.active {
      .icon:before {
        background: $color-green;
      }
    }
  }
}
